// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3SmyE","title":"Header_title__XsRO7","left":"Header_left__2k5U0","clinicName":"Header_clinicName__2Z1e6"};